module.exports = __webpack_public_path__ + "img/mars-stroke-v.0b6eca14.svg";